import React from 'react';

import './AccountNav.scss';

import { Routes } from '../../routes';
import { MenuItem } from '../../models/menuItem';
import LogoutLink from './LogoutLink';
import { EDUCATOR_USER, GUARDIAN_USER } from '../../models/roleModel';
import SecondaryNav from './SecondaryNav';

const accountNavLinks: MenuItem[] = [{
  title: 'Account',
  href: Routes.Account.User.Edit,
  roles: [EDUCATOR_USER, GUARDIAN_USER],
}, {
  title: 'School',
  href: Routes.Account.Schools.Index,
  roles: [EDUCATOR_USER],
}, {
  title: 'Islands',
  href: Routes.Account.Islands.Index,
  roles: [GUARDIAN_USER],
}, {
  title: 'Students',
  href: Routes.Account.Islands.Index,
  roles: [EDUCATOR_USER],
}, {
  title: 'Leaderboard',
  href: Routes.Account.Leaderboard.Index,
  roles: [EDUCATOR_USER],
}];

const AccountNav = (): React.ReactElement => (
  <div className="account-nav">
    <div className="menu">
      <SecondaryNav menuItems={accountNavLinks} />
    </div>

    <div className="logout">
      <LogoutLink />
    </div>
  </div>
);

export default AccountNav;
